import { RIGHTWARDS_ARROW } from 'constants/entities';
import React from 'react';
import { Heading } from '@landr/maestro';
import { RouterLink } from 'components/CommonUi/RouterLink';
import { InstrumentationOptions } from 'types';
import {
    CtaGoal,
    CtaType,
    InteractionSource,
} from 'utils/analytics/AnalyticsV2Service.generated';
import { analytics } from 'utils/analytics';
import { css } from '@landr/styled-system/css';
import { useGenericCarouselContext } from '../GenericCarouselContext';

const headingStyles = css({
    display: 'inline-block',
    marginBottom: 0,
});

export const Title = () => {
    const { carouselName, carouselId, carouselUrl, linkLocation } =
        useGenericCarouselContext();

    const titleUrl = linkLocation === 'Title' ? carouselUrl : undefined;

    // ANALYTICS
    const instrumentationOptions: InstrumentationOptions = {
        goal: 'Show More',
        interactionSource: `Title ${carouselName}`,
        ...(carouselName && { 'L - Carousel Name': carouselName }),
        ...(carouselId && { 'L - Carousel ID': carouselId }),
    };

    return (
        <RouterLink
            to={titleUrl}
            instrumentationOptions={instrumentationOptions}
            onClick={() => {
                analytics.trackCTAClicked({
                    ctaGoal: CtaGoal.ShowMore,
                    ctaType: CtaType.PlainText,
                    interactionSource: InteractionSource.TextAction,
                    ctaDestination: titleUrl || undefined,
                    ctaText: carouselName,
                });
            }}
        >
            <Heading
                className={headingStyles}
                data-generic-carousel-heading
                as="h5"
                textStyle="title-sm"
                mb="2xs"
                data-testid="carousel-title"
            >
                {carouselName}
                {titleUrl && RIGHTWARDS_ARROW}
            </Heading>
        </RouterLink>
    );
};
